import { MenuProps } from "antd";
import { AuthContextType } from "@/contexts";
import { UserPermission } from "@/domains/user";

type MenuItem = Required<MenuProps>["items"][number];

// TODO: refactor by permission:route map
export const getMenu = (auth: AuthContextType) => {
  const items: MenuItem[] = [];

  items.push({
    label: "總覽頁",
    key: "/",
  });

  const operatorReportItems: MenuItem[] = [];

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_member_deposit_records
    )
  )
    operatorReportItems.push({
      label: "會員代收紀錄",
      key: "/operator/reports/member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_member_withdraw_records
    )
  )
    operatorReportItems.push({
      label: "會員代付紀錄",
      key: "/operator/reports/member-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_reports_withdraw_records))
    operatorReportItems.push({
      label: "商戶存單紀錄",
      key: "/operator/reports/tenant-deposit",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_reports_deposit_records))
    operatorReportItems.push({
      label: "商戶提單紀錄",
      key: "/operator/reports/tenant-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_operator_reports_self_deposit_records)
  )
    operatorReportItems.push({
      label: "上存紀錄",
      key: "/operator/reports/self-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_self_withdraw_records
    )
  )
    operatorReportItems.push({
      label: "下發紀錄",
      key: "/operator/reports/self-withdraw",
    });

  if (operatorReportItems.length)
    items.push({
      label: "系統報表",
      key: "/operator/reports",
      children: operatorReportItems,
    });

  const operatorManagementItems: MenuItem[] = [];

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_wallets))
    operatorManagementItems.push({
      label: "錢包管理",
      key: "/operator/management/wallets",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_tenants))
    operatorManagementItems.push({
      label: "商戶管理",
      key: "/operator/management/tenants",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_options))
    operatorManagementItems.push({
      label: "系統設定",
      key: "/operator/management/options",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_operations))
    operatorManagementItems.push({
      label: "操作紀錄",
      key: "/operator/management/operations",
    });

  if (operatorManagementItems.length)
    items.push({
      label: "系統管理",
      key: "/operator/management",
      children: operatorManagementItems,
    });

  const tenantReportItems: MenuItem[] = [];

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_member_deposit_records)
  )
    tenantReportItems.push({
      label: "會員代收紀錄",
      key: "/tenant/reports/member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_reports_member_withdraw_records
    )
  )
    tenantReportItems.push({
      label: "會員代付紀錄",
      key: "/tenant/reports/member-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_self_deposit_records)
  )
    tenantReportItems.push({
      label: "上存紀錄",
      key: "/tenant/reports/self-deposit",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_self_withdraw_records)
  )
    tenantReportItems.push({
      label: "下發紀錄",
      key: "/tenant/reports/self-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_daily_deposit_records)
  )
    tenantReportItems.push({
      label: "代收日報表",
      key: "/tenant/reports/daily-deposit",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_daily_withdraw_records)
  )
    tenantReportItems.push({
      label: "代付日報表",
      key: "/tenant/reports/daily-withdraw",
    });

  if (tenantReportItems.length)
    items.push({
      label: "平台報表",
      key: "/tenant/reports",
      children: tenantReportItems,
    });

  const tenantManagementItems: MenuItem[] = [];

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_member_deposit
    )
  )
    tenantManagementItems.push({
      label: "申請會員代收",
      key: "/tenant/management/create-member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_member_withdraw
    )
  )
    tenantManagementItems.push({
      label: "申請會員代付",
      key: "/tenant/management/create-member-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_members))
    tenantManagementItems.push({
      label: "會員管理",
      key: "/tenant/management/members",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_options))
    tenantManagementItems.push({
      label: "平台設定",
      key: "/tenant/management/options",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_operations))
    tenantManagementItems.push({
      label: "操作紀錄",
      key: "/tenant/management/operations",
    });

  if (tenantManagementItems.length)
    items.push({
      label: "平台管理",
      key: "/tenant/management",
      children: tenantManagementItems,
    });

  return items;
};
